import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

/**
 * Browser entry point.
 *
 * StrictMode is left on intentionally — it surfaces double-effect bugs at
 * dev time, and the cost of the extra render is invisible in dev. In
 * production builds React strips it from the tree, so there's no runtime
 * cost there either.
 */
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container "#root" not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
